module.exports = __webpack_public_path__ + "static/media/PA-Icon-Stra├Яenbahn-pos.e86dcaff.svg";